// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2Mu8I","rootCenter":"LoadMoreObserver_rootCenter__3yUqt","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1nhsM"};